<!-- SalesIndex.vue -->
<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Bons de livraison",
          icon: "bi bi-bag-check-fill",
          route: "sales-index",
        },
        {
          label: "Remarquées",
          icon: "bi bi-sticky-fill",
          route: "sales-noticed-index",
        },
        {
          label: "Nouvelle vente",
          icon: "bi bi-bag-plus-fill",
          route: "sales-create",
        },
      ],
    };
  },
};
</script>
